import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {IApiSecretKey} from '../../../../commons/interfaces/IApiSecretKey';

class ApiSecretKeyController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$uibModal',
    '$state'
  ];

  constructor(
    // puoi definire il tipo di scope, ti aiuta il compilatore dopo con le varie proprieta
    private $scope: {
      data: IApiSecretKey,
      // questa cosa serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
  ) {
    $scope.pageHeader = 'Api Secret Key';
    $scope.isActivationApiClientSection = true;
    $rootScope.formsubmitted = false;
    $scope.isActivationApiClient = false;
    $scope.isActivationApiClientError = false;

    $scope.data = {
      clientId: '',
      clientSecret: '',
      nomeRivenditore: ''
    };

    $scope.attivazioneApiClientModal = (data, size) => {
      const activationCodeModal = $uibModal.open({
        animation: true,
        component: 'apiSecretModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: () => {
            return data;
          }
        }
      });

      activationCodeModal.result.then((response) => {

        if (response.statusText === 'Internal Server Error') {
          console.error(JSON.stringify(response));
          console.error('errrCode: ', response.data.errorCode);
          $scope.isActivationApiClientSection = false;
          $scope.isActivationApiClient = false;
          $scope.isActivationApiClientError = true;
          $scope.activationApiError = response.data.errorDescription;
        } else {
          $scope.isActivationApiClientError = false;
          $scope.isActivationApiClientSection = false;
          const rivenditore = 'Rivenditore: ';
          $scope.rivenditore = `${rivenditore} ${$scope.data.nomeRivenditore}`;
          $scope.isActivationApiClient = true;
          $scope.clientId = response.clientId;
          $scope.clientSecret = $scope.data.clientSecret;
        }

      }).catch((error) => {
        console.error(JSON.stringify(error));
      });

    };

    $scope.ok = () => {
      window.location.reload();
    };

  }

}


export const ApiSecretKeyComponent: ng.IComponentOptions = {
  template: require('./api-secret-key.html'),
  controller: ApiSecretKeyController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/api-secret-key/api-secret-key.ts